import operandType from '../../../../infrastructure/constants/functions/operandType';
import SelectOption from '../../../../infrastructure/types/SelectOption';

const exchangeRatesResultSetOptions: SelectOption[] = [
    { text: 'EXCHANGE-RATES', value: operandType.exchangeRatesResultSet }
];

export { exchangeRatesResultSetOptions };
